export const getWindowWidth = () => {
    return window.innerWidth
}